// Buy and back bike
export const BACK_PROPERTY_TRANSFER_REQUEST = "RETOUR"
export const BUY_PROPERTY_TRANSFER_REQUEST = "RACHAT"
export const TAKEOWNERSHIP_PROPERTY_TRANSFER_REQUEST = "TAKEOWNERSHIP"

export const REQUEST_RENEW = "REQUEST_RENEW"
export const REQUEST_CANCEL = "REQUEST_CANCEL"

export const REQUEST_REJECTED = "rejected"
export const REQUEST_ACCEPTED = "accepted"
export const REQUEST_ONGOING = "ongoing"
export const REQUEST_FORCED = "forced"

// Portability
export const TYPE_REQUEST = "REQUEST"
export const TYPE_REQUEST_CANCEL = "CANCEL"
